const default_hostname = "h5.btcc.com";
const config = {
  "h5.btcc.academy": {
    logo: "/btcc-academy.svg",
    name: "BTCC Academy",
    emailSuffix: "btcc.academy", //邮箱后缀
    ios_prd: "",
    ios_beta: "",
    android_prd:
      "https://play.google.com/store/apps/details?id=com.btcc.academy",
    android_beta: "https://downloads.btcc.academy/btcc_academy_beta.apk",
    title: {
      "zh-cn": "解码加密世界，赋能链上未来",
      "zh-tw": "解碼加密世界，賦能鏈上未來",
      "en-us": "Decoding Crypto, Empowering the Chain's Future",
      "vi-vn":
        "Giải mã thế giới được mã hóa,Trao quyền cho Tương lai trên Chuỗi",
      "ko-kr": "암호화된 세계를 해독하다,체인 위의 미래를 강화하다",
      "ja-jp": "暗号化された世界を解読する",
    },
    slogan: {},
  },
  "h5.btcc.com": {
    logo: "/btcc.png",
    name: "BTCC",
    emailSuffix: "btcc.com", //邮箱后缀
    ios_prd: "https://btcc-media.onelink.me/44GQ/1e313410",
    android_prd: "https://btcc-media.onelink.me/44GQ/1e313410",
    ios_beta: "https://testflight.apple.com/join/avIqvmrR",
    android_beta: "https://downloads.btcc.com/btcchy_beta.apk",
  },
  "h5.dracotopcdn.com": {
    logo: "/dracotop.png",
    name: "Dracotop",
    emailSuffix: "dracotop.com",
    ios_prd: "",
    ios_beta: "",
    android_prd:
      "https://play.google.com/store/apps/details?id=com.dracotop.global",
    android_beta: "https://downloads.dracotopcdn.com/dracotop_beta.apk",
  },
  "h5.xotradecdn.com": {
    logo: "/xotrade.png",
    name: "XO Trade",
    emailSuffix: "xotrade.com",
    ios_prd: "",
    ios_beta: "",
    android_prd:
      "https://play.google.com/store/apps/details?id=com.xotrade.global",
    android_beta: "https://downloads.xotradecdn.com/xotrade_beta.apk",
  },
  "h5.dipnex.com": {
    logo: "/dipnex.png",
    name: "Dipnex",
    emailSuffix: "dipnex.com",
    ios_prd: "",
    ios_beta: "",
    android_prd:
      "https://play.google.com/store/apps/details?id=com.dipnex.global",
    android_beta: "https://downloads.dipnexcdn.com/dipnex_beta.apk",
  },
};

if (process.env.BUILD_ENV === "uat") {
  config["h5-dipnex.cryptouat.com"] = config["h5.dipnex.com"];
}

const searchParams = new URLSearchParams(window.location.search);
export const platform =
  searchParams.get("hostname") || window.location.hostname;

export default config[platform] || config[default_hostname];
